import { Button, Card, CardContent, Input } from '@repo/shadcn';
import { useDebounce } from '@uidotdev/usehooks';
import { useRef, useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { toast } from 'sonner';

import { AutoCompleteInput } from '../../../components/ui/autocomplete/auto-complete-input';
import { useGetCartStocksQuery } from '../../../features/slice/inventory';
import { formatCurrencyInBDT } from '../../../utils';
import { ConfirmOrderForm } from './schema';

const defaultValue = { label: '', value: '' };

export const AddProduct = () => {
    const [searchInputText, setSearchInputText] = useState('');
    const [availableQuantity, setAvailableQuantity] = useState<number | null>(
        null,
    );

    const [quantity, setQuantity] = useState('');
    const [productVariationId, setProductVariationId] = useState('');
    const [price, setPrice] = useState<number | undefined>(undefined);
    const debouncedSearchText = useDebounce(searchInputText, 100);

    const productAutoCompleteRef = useRef<HTMLButtonElement>(null);
    const quantityInputRef = useRef<HTMLInputElement>(null);

    const { control } = useFormContext<ConfirmOrderForm>();
    const { append } = useFieldArray({
        control,
        name: 'items',
    });

    const {
        data: productList,
        isLoading,
        isFetching,
    } = useGetCartStocksQuery({
        // limit: 10,
        // page: 1,
        search: debouncedSearchText,
    });

    const options = productList?.data.map((product: any) => ({
        label: `${product.name}`,
        value: `${product.product_variation_id}`,
        quantity: product.quantity,
        expiry_date: product.expiration_date,
        type: product.type,
        retail_price: product.retail_price,
        wholesale_price: product.wholesale_price,
        brand: product.brand || '',
        strength: product.strength,
        name: product.name,
        product_name: product.name,
        unit: product.unit,
        purchase_price: product.purchase_price,
    }));

    const onValueChange = (value: { label: string; value: string }) => {
        const isCleared = value.value === '' && value.label === '';

        if (isCleared) {
            setPrice(undefined);
            setQuantity('');
            setProductVariationId('');
            setAvailableQuantity(null);
            return;
        }

        const wholesalePrice = (value as any).wholesale_price;

        setPrice(wholesalePrice);
        setProductVariationId(value.value);

        setAvailableQuantity((value as any).quantity || null);

        setTimeout(() => {
            quantityInputRef.current?.focus();
        }, 0);
    };

    const onInputChange = (input: string) => {
        setSearchInputText(input);
    };

    const handleAddProduct = (value: any) => {
        console.log(value);

        const product = options?.find(
            (option) => option.value === productVariationId,
        );

        if (!product) {
            toast.error('Product not found!');
            return;
        }

        console.log('Selected Product:', product);

        // Handle form submission logic here
        append({
            product_variation_id: productVariationId,
            product_name: product.product_name,
            quantity: Number(quantity),
            wholesale_price: price || 0,
            purchase_price: product.purchase_price,
            retail_price: product.retail_price,
            available_quantity: availableQuantity || 0,
        });
    };

    return (
        <Card className="mb-4 pt-4">
            {/* <CardHeader><CardTitle>Add Product</CardTitle></CardHeader> */}
            <CardContent className="flex gap-4">
                <div className="flex-1">
                    <span>Search Product</span>
                    <AutoCompleteInput
                        ref={productAutoCompleteRef}
                        options={options || []}
                        emptyMessage="No match found!"
                        onValueChange={onValueChange}
                        placeholder={'Select product'}
                        value={defaultValue}
                        onInputChange={onInputChange}
                        isLoading={isLoading || isFetching}
                        renderOption={(option) => {
                            const name = `${option.name} ${option.unit}`;
                            // const brand = (option as any).brand;
                            const quantity = (option as any).quantity;
                            const expiryDate = (option as any).expiry_date;
                            const wholesalePrice = (option as any)
                                .wholesale_price;

                            const price = wholesalePrice;

                            return (
                                <div className="flex w-full items-center justify-between space-y-1">
                                    <span>
                                        {name} {formatCurrencyInBDT(price)} (
                                        {new Date(
                                            expiryDate,
                                        ).toLocaleDateString()}
                                        )
                                    </span>
                                    <span>Qty- {quantity}</span>
                                </div>
                            );
                        }}
                    />
                </div>
                <div className="flex items-start">
                    <div>
                        <span>
                            Quantity
                            {availableQuantity !== null
                                ? ` (${availableQuantity})`
                                : ''}
                        </span>
                        <Input
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            ref={quantityInputRef}
                            className="w-24"
                            disabled={availableQuantity === null}
                        />
                    </div>
                    <div className="mb-0.5 flex items-end self-stretch">
                        <Button type="button" onClick={handleAddProduct}>
                            Add
                        </Button>
                    </div>
                    {/* <IwForm
                        schema={AddWholesaleProductFormSchema}
                        initialValues={initialValue}
                        onSubmit={handleAddProduct}
                        ref={formRef}
                    >
                        <div className="mt-2 grid grid-cols-4 gap-2">
                            <TextField<
                                z.infer<typeof AddWholesaleProductFormSchema>
                            >
                                name="quantity"
                                label={`Quantity ${availableQuantity !== null ? `(${availableQuantity})` : ''}`}
                                ref={quantityInputRef}
                            />

                            <Button
                                className="self-end"
                                type="button"
                                disabled={false}
                            >
                                Add
                            </Button>
                        </div>
                    </IwForm> */}
                </div>
            </CardContent>
        </Card>
    );
};
